function sliderRecommendation() {
    $('.slider__recommendation').slick({
        accessibility: true,
        infinite: false,
        slidesToShow: 4.4,
        slidesToScroll: 1,
        swipeToSlide: true,
        touchThreshold: 100,
        dots: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1580,
                settings: {
                    slidesToShow: 3.4,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 2,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });
}

function countTiles() {
    let sum = $('.tiles').length;
    $('.tiles').each(function(i,v) {
        if (i + 1 == sum) {
            $(v).addClass('tiles__last');
        }
    })
}